<template>
    <div class="table_wrap">
        <div class="c_table_wrap table_search_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">검색</td>
                    <td>
                        <div class="search">
                            <el-select
                                v-model="searchInputOption"
                                placeholder="검색방식"
                                class="table_s_select"
                            >
                                <el-option
                                    v-for="(item, index) in searchInputOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                            <el-input
                                    class="table_s_input"
                                    v-model="searchInput"
                                    size=""
                                    prefix-icon="el-icon-search"
                                    placeholder="검색어를 입력해주세요."
                                    maxLength="40"
                                    @keyup.enter.native="runFilter(searchInputOption, searchInput)"
                            >
                            </el-input>
                            <el-button type="primary" class="ml10" @click="runFilter(searchInputOption, searchInput)">
                                검색
                            </el-button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">일시</td>
                    <td>
                        <div class="date">
                            <el-date-picker
                                v-model="filterDate"
                                type="daterange"
                                range-separator="~"
                                value-format="yyyy-MM-dd"
                                start-placeholder="시작날짜"
                                end-placeholder="끝 날짜"
                                @change="changeDateRange(filterDate)"
                            ></el-date-picker>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import util from "@/mixins/util";
    import orderUtil from "@/components/order/orderUtil";
    import {mapState, mapGetters} from "vuex"
    const {filterConfig} = orderUtil;
    export default {
        name: "OrderFilterDefaultLayout",
        mixins: [],
        components: {
        },
        props:{
            filterData: {},
            setFilter: {
                type: Function,
                default: () => {}
            }
        },
        data() {
            return {
                searchInput: '',
                searchInputOption: 'ni',
                searchInputOptions: [
                    {value: 'ni', label: '닉네임'},
                    {value: 'mid', label: '아이디'},
                    {value: 'na', label: '상품명'},
                    {value: 'oid', label: '결제번호'},
                ],
                filterDate: ['', ''],
            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {
            this.setterFilterDataInData();
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{
            setterFilterDataInData() {
                let classnames = Object.keys(this.filterData);
                classnames.forEach(classname => {
                    let obj = this.filterData[classname];
                    let type = filterConfig[obj.key].type;
                    if(this.hasOwnProperty(classname)) {
                        if(type == 'query') {
                            this[classname] = obj.query;
                        }else if(type === 'between') {
                            if(obj.key === 'cr') {
                                let crStart = this.$moment.unix(obj.start).locale('ko').format('YYYY-MM-DD')
                                let crEnd = this.$moment.unix(obj.end).locale('ko').add(-1, 'd').format('YYYY-MM-DD');
                                this[classname] = [crStart, crEnd];
                            }else{
                                this[classname] = [obj.start, obj.end];
                            }
                        }else if(type === 'match') {
                            this[classname] = obj.value;
                        }
                        if(this.hasOwnProperty(`${classname}Option`)) {
                            this[`${classname}Option`] = obj.key;
                        }
                    }
                })
            },
            changeDateRange(arr) {
                if(util.isEmpty(arr) || arr.length != 2) {
                    this.runFilter('cr', null);
                }else{
                    let startDay = this.$moment.utc(arr[0] + ' 00:00:00').locale('en');
                    let endDay = this.$moment.utc(arr[1] + ' 23:59:59').locale('en');
                    let startTimeStamp = Math.floor(startDay.valueOf() / 1000);
                    let endTimeStamp = Math.floor(endDay.valueOf() / 1000);

                    this.runFilter('cr', [startTimeStamp, endTimeStamp]);
                }
            },
            setData(key, value) {
                this[key] = value;
            },
            runFilter(key, value) {
                this.setFilter(key, value)
            }
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>